import { useState } from 'react';
import { RequestServer } from '../../../utils/services';
import { useSnackbar } from 'notistack';
import { agendaObj } from '../../../organisms/project/project-agenda/agenda-expert-panel/types';
interface QuestionForCreateUpdate {
  question: string;
  expert_note_required: boolean;
}

export const useAgendaApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const fetchAgendas = async (projectId: string, agendaId?: string): Promise<agendaObj[]> => {
    setIsLoading(true);
    try {
      const response = await RequestServer(
        `/projects/agenda?action=GetAgenda&fk_project=${projectId}&embed=YES` + (agendaId ? `&id=${agendaId}` : ''),
        "GET"
      );
      return response?.data || [];
    } catch (error) {
      enqueueSnackbar("Failed to fetch agendas", { variant: "error" });
      console.error("Failed to fetch agendas", error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const createAgenda = async (projectId: string, title: string, questions: QuestionForCreateUpdate[]) => {
    setIsLoading(true);
    try {
      const response = await RequestServer(
        `/projects/agenda`,
        "POST",
        {
          action: "Add",
          fk_project: parseInt(projectId),
          title,
          agenda: { questions },
        }
      );
      enqueueSnackbar(response.message, {
        variant: response?.success ? "success" : "warning",
      });
      return response;
    } catch (error) {
      enqueueSnackbar("Failed to create agenda", { variant: "error" });
      console.error("Failed to create agenda", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const updateAgenda = async (agendaId: string, questions: QuestionForCreateUpdate[], title: string) => {
    setIsLoading(true);
    try {
      const payload: any = {
        action: "Update",
        id: parseInt(agendaId),
        title,
        agenda: { questions },
      };
      
      const response = await RequestServer(
        `/projects/agenda/update`,
        "PATCH",
        payload
      );
      enqueueSnackbar(response.message, {
        variant: response?.success ? "success" : "warning",
      });
      return response;
    } catch (error) {
      enqueueSnackbar("Failed to update agenda", { variant: "error" });
      console.error("Failed to update agenda", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    fetchAgendas,
    createAgenda,
    updateAgenda,
  };
};